"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var FeTextEnrichment = function FeTextEnrichment(props) {
  /** Minimum condition required to render*/
  if (!(props.label || props.children)) {
    return null;
  }
  /** Rendering of component */


  var className = (0, _classnames.default)('fe-text-enrich', [props.feType !== 'default' ? "fe-text-enrich--".concat(props.feType) : ''], props.className);
  var otherProps = Object.assign({}, props);
  delete otherProps.label;
  delete otherProps.feType;
  delete otherProps.maxChar;
  delete otherProps.className;
  var label = props.label && props.maxChar && (0, _utils.truncateString)(props.label, props.maxChar, true) || props.label;
  return _react.default.createElement("button", _extends({
    type: "button",
    className: className
  }, otherProps), label, props.children);
};

FeTextEnrichment.defaultProps = {
  label: null,
  feType: 'default',
  maxChar: null
};
FeTextEnrichment.propTypes = {
  /** Provide label */
  label: _propTypes.default.string,

  /** Provide fetype like 'default', 'info', 'warning', 'danger'*/
  feType: _propTypes.default.oneOf(['default', 'info', 'warning', 'danger']),

  /** Provide max character for truncation */
  maxChar: _propTypes.default.number
};
FeTextEnrichment.displayName = 'FeTextEnrichment';
var _default = FeTextEnrichment;
exports.default = _default;